import styled from "styled-components"

const SignInSignUpContainer = styled.section`
    width: 85%;

    display: flex;
    flex-direction: column;
    align-items: center;
    
    a{
        text-decoration: none;
        color: #D4CFCC;
    }
`

export default SignInSignUpContainer;
